import Configuration from '@/configuration/configuration'
import { Pastilles } from '@/domain/Pastilles'
import DatePicker from '../layout/components/DatePicker.vue'
import Vue from 'vue'
import _ from 'lodash'
import { HubConnectionBuilder } from '@microsoft/signalr'

export default Vue.extend({
    components: { DatePicker },
    data() {
        return { companiesLoaded: false, pastillesLoaded: false, userLoaded: false }
    },
    methods: {
        loadCompany() {
            this.$http
                .api('company/all')
                .get()
                .then(x => {
                    this.$database.feed({ companies: x.data })
                    this.$database.save()
                    this.companiesLoaded = true
                })
                .catch(x => this.$swal.toast.errorApi(x))
        },
        loadPastilles() {
            this.$http
                .api('pastilles')
                .get()
                .then(x => {
                    this.$database.feed({ pastilles: x.data })
                    this.$database.save()
                    this.pastillesLoaded = true
                })
                .catch(x => this.$swal.toast.errorApi(x))
        },
        loadUserForSelection() {
            this.$http
                .api('user/get-all-for-selection')
                .get()
                .then(x => {
                    this.$database.feed({ usersForSelection: x.data })
                    this.$database.save()
                    this.userLoaded = true
                })
                .catch(x => this.$swal.toast.errorApi(x))
        },
        widthCanvas() {
            return document.body.offsetWidth * 0.8
        },
        heightCanvas() {
            return Math.round(document.body.offsetHeight * 0.6)
        },
        isFilled: function(value: string) {
            return value !== null && value !== ''
        },
        constructFileDownloadUrl(identifiantTelechargement: string) {
            return `${Configuration.apiUrl}/api/file/${identifiantTelechargement}`
        },
        formatEntreprise(codeClient: string) {
            const entreprise = _.find(this.$database.companies, e => e.code == codeClient)
            if (entreprise) return `${entreprise.libelle}`

            return null
        },
        blobToBase64(blob: Blob) {
            return new Promise<string>((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onload = () => resolve(reader.result as string);
                reader.onerror = error => reject(error);
            });
        }
    },
    computed: {
        usersForSelection() {
            if (!this.userLoaded && this.$database.usersForSelection.length == 0) this.loadUserForSelection()

            return this.$database.usersForSelection.map(usr => {
                return {
                    text: usr.label,
                    value: usr.id
                }
            })
        },
        companiesAutoComplete() {
            if (!this.companiesLoaded && this.$database.companies.length == 0) this.loadCompany()

            return this.$database.companies.map(company => {
                return {
                    text: company.libelle,
                    value: company.code
                }
            })
        },
        pastilles: function(): Pastilles {
            if (!this.pastillesLoaded) {
                this.loadPastilles()
            }

            return this.$database.pastilles
        }
    },
    mounted() {
        if (!this.pastillesLoaded) {
            const connection = new HubConnectionBuilder().withUrl(process.env.VUE_APP_API_URL + '/hubs/refresh').build()

            connection.start().then(() => {
                connection.on('RefreshPastilles', () => {
                    this.loadPastilles()
                })
            })
        }
    }
})
